import { Select } from 'antd'
import { useEffect, useState } from 'react'
import type { JsonData } from 'react-toolkits'
import { useToolkitsStore } from 'react-toolkits'
import { selectSchema } from '../schemas/select'
import { withFormItem } from './form-item'

export const SelectRenderer = withFormItem(selectSchema)(childrenProps => {
  const { type, options, source, width, ...rest } = childrenProps
  const { axios } = useToolkitsStore(s => s)
  const [internalOptions, setInternalOptions] = useState<{ label: string; value: string | number }[]>()

  useEffect(() => {
    if (source) {
      axios
        .get<JsonData<{ options: { label: string; value: string | number }[] }>>(source)
        .then(response => {
          setInternalOptions(response.data?.data?.options)
        })
        .catch(() => {
          setInternalOptions([])
        })
    } else if (options) {
      setInternalOptions(options)
    }
  }, [source])

  return <Select {...rest} options={internalOptions} style={{ width }} />
})
